var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1C7 0.447715 7.44772 0 8 0C8.55228 0 9 0.447715 9 1V8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8V1Z",
    fill: "#73777C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.80275V1.00005C11 0.853758 10.9895 0.709909 10.9693 0.569215C13.9174 1.7483 16 4.63096 16 8.00005C16 12.4183 12.4183 16.0001 8 16.0001C3.58172 16.0001 0 12.4183 0 8.00005C0 4.63097 2.08262 1.7483 5.03071 0.569214C5.01047 0.709908 5 0.853757 5 1.00005V2.80275C3.2066 3.84017 2 5.7792 2 8.00005C2 11.3138 4.68629 14.0001 8 14.0001C11.3137 14.0001 14 11.3138 14 8.00005C14 5.7792 12.7934 3.84017 11 2.80275Z",
    fill: "#73777C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.ae0d8ad138f7e91098f7d7ffe81e1258.svg";
export { ForwardRef as ReactComponent };